export enum HeaderTabs {
  APPLICATION = "application",
  TASKS = "tasks"
}
